import React, { useState } from 'react';
import { TriangleInvertedFilled } from '../Icons/Triangle';
import styled from '@emotion/styled';
import { getMonths, getDaysInMonth } from '../../utils/utils';
import { Add } from '../Icons/Add';

const ReminderCalendar = () => {
  const today = new Date();
  const [selectedMonthIndex, setSelectedMonthIndex] = useState(
    today.getMonth()
  );
  const [selectedDate, setSelectedDate] = useState<number | null>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleMonthClick = () => setDropdownOpen(!dropdownOpen);
  const handleMonthSelect = (index: number) => {
    setSelectedMonthIndex(index);
    setSelectedDate(null);
    setDropdownOpen(false);
  };

  const months = getMonths();

  const handleDateSelect = (day: number) => {
    setSelectedDate(day);
    console.log(`${months[selectedMonthIndex]} ${day}`);
  };

  return (
    <Container>
      <Header>
        <MonthSelector onClick={handleMonthClick}>
          {months[selectedMonthIndex]} <TriangleInvertedFilled />
          {dropdownOpen && (
            <Dropdown>
              {months.map((month, idx) => (
                <li key={month} onClick={() => handleMonthSelect(idx)}>
                  {month}
                </li>
              ))}
            </Dropdown>
          )}
        </MonthSelector>

        <AddReminderButton disabled={!selectedDate}>
          <Add /> Add reminder
        </AddReminderButton>
      </Header>

      <DateScrollContainer>
        {getDaysInMonth(selectedMonthIndex, today.getFullYear()).map(
          ({ day, date }, idx) => (
            <DateItem
              key={idx}
              selected={selectedDate === date}
              onClick={() => handleDateSelect(date)}
            >
              <span className="day">{day}</span>
              <span className="date">{date}</span>
            </DateItem>
          )
        )}
      </DateScrollContainer>
    </Container>
  );
};

export default ReminderCalendar;


const Container = styled.div`
  width: 100%;
  border-top: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  max-width: 270px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap:rem;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const MonthSelector = styled.div`
  position: relative;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.25rem;

  ul {
    list-style: none;
    padding: 0.25rem 0;
    margin: 0;
  }
`;

const Dropdown = styled.ul`
  position: absolute;
  top: 1.5rem;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  z-index: 10;
  width: max-content;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  li {
    padding: 0.5rem 1rem;
    cursor: pointer;
    &:hover {
      background: #f1f1f1;
    }
  }
`;

const AddReminderButton = styled.p<{ disabled: boolean }>`
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -1px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ disabled, theme }) =>
    disabled ? theme.palette.greyGrey3 : theme.palette.stateColorBlue};
  display: flex;
  gap: 5px;
`;

const DateScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 0.5rem;
  padding: 0.5rem 0;
`;

const DateItem = styled.div<{ selected: boolean }>`
  min-width: 40px;
  height: 74px;
  border-radius: 100px;
  background-color: ${({ selected, theme }) =>
    selected ? theme.palette.stateColorGreenLight : ''};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;

  .day {
    font-weight: 500;
    font-size: 13px;
    color: ${({ selected, theme }) =>
      selected ? theme.palette.stateColorGreen : theme.palette.greyGrey3};
  }

  .date {
    font-weight: 700;
    font-size: 15px;
    line-height: 100%;
    color: ${({ selected, theme }) =>
      selected ? theme.palette.stateColorGreen : '#59748A'};
  }
`;
